import React, {useState, useEffect, useContext } from 'react';
import Button from 'react-bootstrap/Button';
import DataTable from 'react-data-table-component';
import { AuthContext } from '../../context/AuthContext';
import { getVacationsHistory } from '../../services/VacationHistoryService';
import { cancelVacations } from '../../services/VacationHistoryService';
import Loader from '../common/Loader';
import { VacationsContext } from '../../context/VacationsContext';
import dayjs from 'dayjs';

const Table = ({ year }) => {
    const { userId } = useContext(AuthContext);
    const { updateParent, setUpdateParent } = useContext(VacationsContext);
    const [users, setUsers] = useState([])
    const [pending, setPending] = useState(true);

    const showData = async () => {
        const res = await getVacationsHistory(userId, year, true);
        let data = [];
        let formatStartDate;
        let formatEndDate;
        for (const key in res) {
            if (res[key].start_date !== null) {
                formatStartDate = dayjs(res[key].start_date).format("DD/MM/YYYY");
                formatEndDate = dayjs(res[key].end_date).format("DD/MM/YYYY");
            }
            data.push({
                start_date: formatStartDate,
                end_date: formatEndDate,
                status: res[key].status,
                total_days: res[key].total_days,
                vacations_id: res[key].vacations_id
            })
        }
        setUsers(data)
    }

    useEffect(() => {
        (async () => {
            const data = await showData();
            if (data) {
                setUsers(data);
            }
            setPending(false);
        })();
    }, [year, updateParent])

    const columns = [
        {
            name: 'Fecha Inicio',
            selector: row => row.start_date
        },
        {
            name: 'Fecha Fin',
            selector: row => row.end_date
        },
        {
            name: 'Status',
            selector: row => row.status
        },
        {
            name: 'Días',
            selector: row => row.total_days
        },
        {
            name: '',
            button: true,
            cell: row => (
                <div>
                    {row.status === 'PENDING' &&
                        <Button variant="outline-danger" onClick={() => {
                            cancelVacationsById(row.vacations_id);
                            setUpdateParent(row.vacations_id);
                        }}>Cancelar</Button>
                    }
                </div>
            ),
        },
    ]

    return (
        <div className="App table">
            <DataTable
                columns={columns}
                data={users}
                striped={true}
                progressPending={pending}
                progressComponent={<Loader />}
                pagination
            />
        </div>
    );
}

export const cancelVacationsById = async (id) => {    
    let formData = {
        vacations_id: id
    }
    await cancelVacations(JSON.stringify(formData));
}

export default Table;